<template>
    <ChatInterface
      :coach="marketerCoach"
      apiEndpoint="/api"
      coachName="Maketer"
    />
  </template>
  
  <script>
  import ChatInterface from '../components/ChatInterface.vue';
  
  export default {
    name: 'CoachMarketer',
    components: {
      ChatInterface,
    },
    data() {
      return {
        marketerCoach: {
          image: require('../assets/image-3.jpg'),
          name: 'MARKETER',
          description: [
            'Modelo Marketer.',
            'Descripción.',
          ],
          disclaimer:
            'Este chat usa un modelo de IA experimental y está en etapa de pruebas, no incluyas información personal ni confidencial ya que podría ser usada para entrenamiento. Este es un proyecto de simulación. No es una representación fiel del personaje y el análisis que se proporciona es con fines orientativos. Elon Musk no está enterado de este proyecto (hasta donde sabemos)',
        },
      };
    },
  };
  </script>